import { Radio as FuseRadio } from '@tvg/fuse-design/radio';
import React from 'react';
import styled from 'styled-components';

const StyledRadio = styled(FuseRadio)`
  margin-left: var(--spacing-space12);

  &.fuse-radio {
    margin-bottom: 0;
    margin-right: 0;
  }
`;

export interface RadioProps {
  position: string;
  value: number;
  label: string;
  checked: boolean;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

function Radio({ position, label, ...props }: RadioProps) {
  const id = `products-per-page-${position}-${label}`;
  const radioName = `products-per-page-${position}`;

  return (
    <StyledRadio
      analyticsId={id}
      dataTestId={id}
      radioLabel={label}
      radioName={radioName}
      srLabel="products per page"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}

export default React.memo(Radio);
